import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-full lg:w-[340px]">
            <div className="relative mx-auto w-[240px]">
              <div className="absolute -inset-6 bg-gradient-to-br from-primary-500/20 to-accent-500/20 rounded-[3rem] blur-2xl" />
              <div className="relative bg-background-50 border-2 border-background-200/70 rounded-[2.5rem] overflow-hidden aspect-[9/16]">
                <div className="h-7 bg-foreground-900" />
                <div className="p-3 space-y-2">
                  <div className="h-2 bg-background-300 rounded-full w-3/4" />
                  <div className="h-2 bg-background-200 rounded-full w-1/2" />
                  <div className="mt-3 grid grid-cols-2 gap-1.5">
                    <div className="aspect-video bg-primary-100 rounded-md" />
                    <div className="aspect-video bg-accent-100 rounded-md" />
                    <div className="aspect-video bg-secondary-100 rounded-md" />
                    <div className="aspect-video bg-primary-100/50 rounded-md" />
                  </div>
                  <div className="h-1.5 bg-background-200 rounded-full w-full mt-2" />
                  <div className="h-1.5 bg-background-200 rounded-full w-2/3" />
                </div>
                <div className="h-8 bg-background-100 border-t border-background-200/50 mt-auto" />
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {appInfo.title}
            </h2>
            <p className="mt-2 text-lg text-foreground-600 font-heading">{appInfo.subtitle}</p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appInfo.desc}
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
              {appInfo.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-7 h-7 bg-accent-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-accent-600 text-sm" />
                  </div>
                  <span>{feat}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg" />
                App Store 下载
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg" />
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}